import script from "./PendingPaymentDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./PendingPaymentDetail.vue?vue&type=script&setup=true&lang=js"

import "./PendingPaymentDetail.vue?vue&type=style&index=0&id=17f06fec&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_influencer_admin_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17f06fec"]])

export default __exports__